import { createContext, useContext, useEffect, useState } from "react";
import { content } from "../lib/i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("bv-lang") || "it");
  useEffect(() => {
    localStorage.setItem("bv-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t: content[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
